module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "userinfo"
    }
  }, [_c('h1', [_vm._v("ユーザー情報")]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('table', [_c('tr', [_c('th', [_vm._v("名前")]), _c('td', [_vm._v(":")]), _c('td', [_vm._v(_vm._s(_vm.fullname))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("カナ")]), _c('td', [_vm._v(":")]), _c('td', [_vm._v(_vm._s(_vm.kana))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("ユーザー名(ID)")]), _c('td', [_vm._v(":")]), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user_name),
      expression: "user_name"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.user_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user_name = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("mail")]), _c('td', [_vm._v(":")]), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mail_address),
      expression: "mail_address"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.mail_address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.mail_address = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("現在のパスワード")]), _c('td', [_vm._v(":")]), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.current_password),
      expression: "current_password"
    }],
    attrs: {
      "type": "password"
    },
    domProps: {
      "value": (_vm.current_password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.current_password = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("新しいパスワード")]), _c('td', [_vm._v(":")]), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    attrs: {
      "type": "password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })])])])]), _vm._v(" "), _c('router-link', {
    staticClass: "button",
    attrs: {
      "tag": "button",
      "to": "/Spuser",
      "title": "キャンセル"
    }
  }, [_c('span', [_vm._v("キャンセル")])]), _c('br'), _vm._v(" "), _c('input', {
    staticClass: "button",
    attrs: {
      "type": "button",
      "value": "変更を適用"
    },
    on: {
      "click": _vm.Apply
    }
  })], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-3ccb94f9", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3ccb94f9"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Mobile/UserInfo/Spchangeuserinfo.vue
// module id = 697
// module chunks = 0